import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL as API } from '../config/api';

const PartnersBanner = () => {
  const { t } = useTranslation();
  const [dynamicPartners, setDynamicPartners] = useState([]);

  // Liste des partenaires statiques (existants)
  const staticPartners = [
    { name: 'CASPAG', logo: '/partner-caspag.jpeg', type: 'partner' },
    { name: 'Éditions CRI DU COEUR', logo: '/partner-ecc.jpeg', type: 'partner' },
    { name: 'Club de Solidarité Mondiale', logo: '/partner-csm.jpeg', type: 'partner' },
    { name: 'EDENLIFE Global Media', logo: '/partner-edenlife-media.jpeg', type: 'partner' },
    { name: 'Starlove Production', logo: 'https://customer-assets.emergentagent.com/job_marathon-raffle-1/artifacts/h9x4c6rz_WhatsApp%20Image%202026-01-27%20at%2012.44.47.jpeg', type: 'partner' },
    { name: 'Clinique Massothérapie Pierre', logo: 'https://customer-assets.emergentagent.com/job_marathon-raffle-1/artifacts/6fkuffza_Wordmark%20Logo%20with%20Bold%20and%20Script%20Fonts%20%282%29.png', type: 'partner' },
    { name: 'FPEH - Forum des Professionnels', logo: '/partner-fpeh.png', type: 'partner' },
    // 3 nouveaux partenaires ajoutés récemment
    { name: 'MIKIE Lioness Digital', logo: 'https://customer-assets.emergentagent.com/job_fc31c2a6-1776-4c34-a612-3e77739c44b4/artifacts/2rbm91pr_MIKIE%20Lioness%20Digital%20Logo%20-%20Emblem%20with%20Navy%20Contrast.jpg', type: 'partner' },
    { name: 'Vision Globale du Royaume', logo: 'https://customer-assets.emergentagent.com/job_fc31c2a6-1776-4c34-a612-3e77739c44b4/artifacts/okiyvj9r_Logo%20Vision%20Globale%20du%20Royaume.png', type: 'partner' },
    { name: 'Salvation Foundation (SAFO)', logo: 'https://customer-assets.emergentagent.com/job_fc31c2a6-1776-4c34-a612-3e77739c44b4/artifacts/112noj9u_WhatsApp%20Image%202026-02-03%20at%2017.36.20.jpeg', type: 'partner' },
  ];

  // Load additional partners from API (if any new ones are added)
  useEffect(() => {
    const loadPartners = async () => {
      try {
        const response = await axios.get(`${API}/partners`);
        if (response.data.partners && response.data.partners.length > 0) {
          // Filter out partners that are already in staticPartners
          const staticNames = staticPartners.map(p => p.name.toLowerCase());
          const newPartners = response.data.partners
            .filter(p => !staticNames.includes(p.name.toLowerCase()))
            .map(p => ({
              name: p.name,
              logo: p.logo_url,
              website: p.website_url,
              type: 'partner'
            }));
          setDynamicPartners(newPartners);
        }
      } catch (error) {
        console.error('Error loading partners:', error);
      }
    };
    loadPartners();
  }, []);

  // Combine static and dynamic partners
  const allPartners = [...staticPartners, ...dynamicPartners];
  
  // Triple the partners for seamless loop on mobile
  const duplicatedPartners = [...allPartners, ...allPartners, ...allPartners];

  return (
    <div className="bg-white/80 backdrop-blur-sm py-4 sm:py-6 overflow-hidden border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 mb-3 sm:mb-4">
        <p className="text-center text-xs sm:text-sm text-gray-500 font-medium uppercase tracking-wider">
          {t('partners.ourPartners')}
        </p>
      </div>
      
      <div className="relative overflow-hidden">
        {/* Gradient masks for smooth edges */}
        <div className="absolute left-0 top-0 bottom-0 w-8 sm:w-16 bg-gradient-to-r from-white/80 to-transparent z-10 pointer-events-none"></div>
        <div className="absolute right-0 top-0 bottom-0 w-8 sm:w-16 bg-gradient-to-l from-white/80 to-transparent z-10 pointer-events-none"></div>
        
        <div className="flex animate-marquee">
          {duplicatedPartners.map((partner, index) => (
            <div
              key={index}
              className="flex-shrink-0 mx-3 sm:mx-6 md:mx-8 flex items-center justify-center"
            >
              {partner.logo ? (
                <img 
                  src={partner.logo} 
                  alt={partner.name} 
                  className="h-10 sm:h-12 md:h-16 w-auto object-contain hover:scale-110 transition-all duration-300 rounded-lg"
                  loading="lazy"
                  onError={(e) => {
                    // Fallback to text if image fails
                    e.target.style.display = 'none';
                    if (e.target.nextSibling) {
                      e.target.nextSibling.style.display = 'flex';
                    }
                  }}
                />
              ) : null}
              <div 
                className="h-10 sm:h-12 px-3 sm:px-6 items-center justify-center bg-gray-100 rounded-lg border border-gray-200 hover:border-primary hover:bg-primary/5 transition-all duration-300"
                style={{ display: partner.logo ? 'none' : 'flex' }}
              >
                <span className="text-gray-600 font-semibold text-xs sm:text-sm md:text-lg whitespace-nowrap">{partner.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PartnersBanner;
